const { NODE_ENV: env = 'local', PORT: port = 8080 } = process.env;

module.exports = {
  env,
  port,
  debug: true,
  mode: 'development',
  sourceMap: true,
  hot: false,
  onlineClientUrlRoot: undefined,
  auth: {
    responseType: 'token id_token',
    scope: 'openid',
    domain: 'staging.auth.localsearch.cloud',
    audience: 'https://services.lsapis.com.au',
    clientID: 'L2UEksyLo3HcbeZYonWyk11HR2BUTxUT',
  },
  token: {
    tolerance: 5 * 60 * 1000, // 5 minutes
    key: 'token',
  },
  compression: {
    level: 0,
  },
  logger: {
    sentry: {
      level: 'error',
      dsn:
        'https://d5ad1aad0c6144efb9760475e2592b7d@o292297.ingest.sentry.io/1836900',
      denyUrls: ['trkcall.com', 'google-analytics.com'],
      ignoreErrors: ['ChunkLoadError'],
      tracesSampleRate: 1.0,
      environment: env,
      authToken:
        '1977c8e1d200466a8acb666d8704f03c0272f0838a614204be20d5e4ee9b3c97',
    },
    console: {
      level: 'debug',
    },
  },
  pagination: {
    pageSize: 10,
  },
  blogApiRoot: 'https://blog.localsearch.com.au',
  apiRoot: 'https://development.daapi.lsapis.com.au',
  serviceApiRoot: 'https://development.services.lsapis.com.au',
  serviceGraphqlRoot: 'https://development.services.lsapis.com.au/graphql',
  imageResizeRoot: 'https://images.development.ls-www.localsearch.cloud',
  b2bApiRoot: 'https://business.localsearch.com.au',
  recaptchaRoot:
    'https://u67big8d6b.execute-api.ap-southeast-2.amazonaws.com/development',
  filemakerApiRoot:
    'https://b1h276ye2f.execute-api.ap-southeast-2.amazonaws.com/development',
  addABusinessRoot:
    'https://forbusiness.development.localsearch.cloud/create-profile',
  googleClientId:
    '121922601136-jc3oavvr6pima25efjf3ucjubid772eq.apps.googleusercontent.com',
  googleRechaptchaKey: '6Lds6HYUAAAAAGJpFNullRbIYkohrW6PEZsD9ftx',
  gtmId: 'GTM-5KM34NG',
  recaptchaMinScore: 0,
  googleMapKey: 'AIzaSyD1scZ4h2kbYhTIMS4zFiiKRDD4wlDPBb0',
  googleYoutubeKey: 'AIzaSyAX_WBafzpbTFPBv5KIhMl7cRkbik5Q2hA',
  googlePartnerId: '4361342073',
  facebookAppId: '374981936001086',
  categoryFilter: ['adult shops', 'adult entertainment & escorts'],
  title: "Localsearch | It's how the locals search!",
  description:
    'Find thousands of local businesses, read & write reviews, request quotes & more. Are you an Aussie business owner? Take a look at our complete digital marketing service.',
  PIDFormAuth: {
    username: 'LSWEB',
    password: 'eTAjOhNX9aHW0YIxAPKht0DJgn98FwbE',
  },
  assetApiAuth: {
    username: 'daapi',
    password: 'eTAjOhNX9aHW0YIx',
  },
  bpm: {
    baseUrl: 'https://forbusiness.localsearch.com.au',
  },
  appleItunesAppId: 'id1471245997',
  secretKey: 'lsBDzMavON',
  elastic: {
    node: 'https://es8.elasticsearch-dev.localsearch.cloud',
    maxSize: 10,
    cacheControl: 'no-cache',
    indexes: {
      cms: 'cms_legacy',
    },
  },
  optimizelyUrl: 'https://fake.Optimizely.URL.for.development.and.QA.testing',
};
